var sw = sw || {};


// Forma za kontakt
//----------------------------------------------------------
sw.formQuery = function() {
    var $form = $('#form-query');

    if (!$form.length) {
        return;
    }

    $form.validate({
        rules: {
            cf_name: {
                required: true,
                minlength: 2
            }, 
            cf_surname: {
                required: true,
                minlength: 2
            },
            cf_telephone: {
                required: true,
                minlength: 6
            },
            cf_email: {
                required: true,
                minlength: 3,
                email: true
            },
            cf_message: {
                required: true,
                minlength: 10
            }
        }
        
        // highlight: function(element) {
        //     $(element).parent().addClass('form__fieldset--error');
        // },
        // unhighlight: function(element) {
        //     $(element).parent().removeClass('form__fieldset--error');
        // }
    });
};






$(document).ready(function (){
    // sw.formQuery();
});